import { Text } from "@react-three/drei";

const GosNIIASDescription = () => {
  return (
    <Text
      position={[0, -0.99, 0]}
      rotation-x={-Math.PI / 2}
      fontSize={0.7}
      color="white"
    >
      {[
        "Role: Software Engineer",
        "Period: 2015 Sep - 2016 Aug",
        "",
        "Tech stack: Python",
        "",
        "Achievements:",
        "ML algorithm for aerial image recognition",
      ].join("\n")}
    </Text>
  );
};

export default GosNIIASDescription;
